import React, { useEffect, useState } from 'react';
import { Container, Col, Row, Nav, NavItem, NavLink } from 'reactstrap';
import { connect } from 'react-redux';
import LoginModal from '../../shared/components/Modals/LoginModal';
import { getApiByFriendlyName } from '../../redux/actions/apis';
import { getPlanByApiAndOrganization } from '../../redux/actions/plans';
import { getImageLayouts, getOrganizationImageDesigns, setSelectedDesign } from '../../redux/actions/linkPreview';
import RateLimitUpgradeModal from '../../shared/components/Modals/UpgradeModals/RateLimitUpgradeModal';

import OrganizationDesigns from '../LinkPreview/components/OrganizationDesigns';
import OrganizationImagesWrapper from './components/OrganizationImagesWrapper';
import ImageTemplateModal from '../LinkPreview/components/ImageTemplateModal/ImageTemplateModal';

const ImageGeneration = (props) => {
  const [displayLoginModal, setDisplayLoginModal] = useState(false);
  const [activeTab, setActiveTab] = useState('designs');
  const [selectedDesign, setSelectedDesignState] = useState(null);

  // Get API information
  useEffect(() => {
    if (!props.api.id && !props.apiError) {
      props.getApiByFriendlyName('Opengraphio');
    }
  }, [props.api]);

  // Check if user is logged in and get plan
  useEffect(() => {
    if (!props.user && !props.userState.loading) {
      setDisplayLoginModal(true);
    }
    if (props.user && props.api.id && !props.plan.id && !props.planError) {
      props.getPlanByApiAndOrganization();
    }
  }, [props.api.id, props.user, props.plan.id, props.planError, props.apiError]);

  // Close login modal when user logs in
  useEffect(() => {
    if (props.user) {
      setDisplayLoginModal(false);
    }
  }, [props.user]);

  // Get organization image designs when necessary
  useEffect(() => {
    if (props.user && props.currentOrganization.information.id && props.plan.id) {
      if (props.imageDesigns.designs.length === 0) {
        props.getOrganizationImageDesigns();
      }
    }
  }, [props.user, props.currentOrganization.information, props.plan.id]);

  // Get image layouts
  useEffect(() => {
    if (props.imageLayouts.layouts.length === 0 && props.plan.id) {
      props.getImageLayouts();
    }
  }, [props.plan.id]);

  // Show images tab when a design is selected
  useEffect(() => {
    if (props.selectedDesign.design) {
      setSelectedDesignState(props.selectedDesign.design);
      if (props.selectedDesign.tabSwitch) {
        setActiveTab('images');
      }
    } else {
      setSelectedDesignState(null);
      setActiveTab('designs');
    }
  }, [props.selectedDesign.design, props.selectedDesign.tabSwitch]);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      
      // If switching back to designs tab, clear the selected design
      if (tab === 'designs' && selectedDesign) {
        props.setSelectedDesign(null);
      }
    }
  };

  // Pass a custom setSelectedDesign function to OrganizationDesigns
  const handleDesignSelect = (design) => {
    props.setSelectedDesign(design);
  };

  return (
    <Container className="dashboard">
      {displayLoginModal ? <LoginModal userState={props.userState} visible={displayLoginModal} /> : ''}
      <RateLimitUpgradeModal />
      {props.plan && props.plan.id && <ImageTemplateModal />}
      
      <Col md={12} xl={12}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', margin: '30px 0', paddingLeft: '15px' }}>
          <h2 style={{ fontSize: '2.5rem', fontWeight: '600', marginBottom: '10px' }}>Image Generation</h2>
          <p style={{ fontSize: '1.1rem', color: '#494949' }}>Create and manage your social media images</p>
        </div>
      </Col>

      <Row>
        <Col md={12}>
          <Nav tabs style={{ marginBottom: '20px', borderBottom: 'none' }} className="image-generation-tabs">
            <NavItem>
              <NavLink
                className={activeTab === 'designs' ? 'form__debugger-tab active-tab' : 'form__debugger-tab'}
                onClick={() => toggleTab('designs')}
              >
                Designs
              </NavLink>
            </NavItem>
            {selectedDesign && (
              <NavItem>
                <NavLink
                  className={activeTab === 'images' ? 'form__debugger-tab active-tab' : 'form__debugger-tab'}
                  onClick={() => toggleTab('images')}
                >
                  Images
                </NavLink>
              </NavItem>
            )}
          </Nav>
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          {activeTab === 'designs' && <OrganizationDesigns onSelectDesign={handleDesignSelect} />}
          {activeTab === 'images' && selectedDesign && <OrganizationImagesWrapper />}
        </Col>
      </Row>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  user: state.users.user,
  userState: state.users,
  plan: state.plans.detailPlan,
  planError: state.plans.error,
  api: state.apis.detailApi,
  apiError: state.apis.error,
  currentOrganization: state.organization.currentOrg,
  imageLayouts: state.linkPreview.imageLayouts,
  imageDesigns: state.linkPreview.imageDesigns,
  selectedDesign: state.linkPreview.selectedDesign,
});

const mapDispatchToProps = (dispatch) => ({
  getPlanByApiAndOrganization: () => dispatch(getPlanByApiAndOrganization()),
  getApiByFriendlyName: (payload) => dispatch(getApiByFriendlyName(payload)),
  getImageLayouts: () => dispatch(getImageLayouts()),
  getOrganizationImageDesigns: () => dispatch(getOrganizationImageDesigns()),
  setSelectedDesign: (design) => dispatch(setSelectedDesign(design)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImageGeneration); 